import { create } from "zustand";
import { VideoPlatformMeeting, VideoPlatformResource } from "../api/video_platform";
import { MEETING_QUERY_PARAMS } from "../components/video_platform/utils";

interface VideoPlatformState {
  meetings: VideoPlatformMeeting[];
  loading: boolean;
  error: string | null;
  loadMeetings: () => Promise<void>;
}

export const useVideoPlatformStore = create<VideoPlatformState>((set) => ({
  meetings: [],
  loading: false,
  error: null,

  loadMeetings: async () => {
    set({ loading: true, error: null });
    try {
      const response = await VideoPlatformResource.getMeetings(MEETING_QUERY_PARAMS);
      set({ meetings: response.data, loading: false });
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load meetings";
      set({ error, loading: false });
    }
  },
}));
